export default __webpack_public_path__ + "static/badge-atlassian-marketplace-d05dcf432cd89b83b93b88f2cfa0ab8b.svg";